// Translations
import accessKeyManager from 'components/model/access-key-manager/translations/ru'
import copyButton from 'components/interface/copy-button/translations/ru'
import pagination from 'components/interface/pagination/translations/ru'
import phoneNumberVerifier from 'components/model/phone-number-verifier/translations/ru'
import providerButton from 'components/external/provider-button/translations/ru'

// Translation: Russian > Components
const components = Object.freeze({
	external: { providerButton },
	interface: { copyButton, pagination },
	model: { accessKeyManager, phoneNumberVerifier }
})

// Export
export default components
